import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton, CircularProgress } from '@mui/material';
import { ArrowBack, FolderOpen } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useGetFacilityGroup } from '@/api/hooks/facility-groups/useGetFacilityGroup';
import PageLayout from '@/components/Layout/PageLayout';
import CardHeader from '@/components/Card/CardHeader';
import FacilityGroupDetailsSection from './FacilityGroupDetailsSection';
import FacilityAssignmentSection from './FacilityAssignmentSection';

const FacilityGroupDetails = () => {
  const { t } = useTranslation();
  const { id: organizationId, groupId } = useParams();
  const navigate = useNavigate();
  const { facilityGroup, loading, refetch } = useGetFacilityGroup(
    organizationId,
    groupId,
  );

  const handleBack = () => {
    navigate(`/admin/updateOrganization/${organizationId}#facility-groups`);
  };

  const handleUpdate = () => {
    refetch();
  };

  const header = (
    <CardHeader color='primary'>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton
          onClick={handleBack}
          sx={{
            mr: 2,
            color: 'white',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.1)',
            },
          }}>
          <ArrowBack sx={{ color: 'white' }} />
        </IconButton>
        <FolderOpen sx={{ color: 'white', mr: 1 }} />
        <Typography
          variant='h6'
          sx={{ color: 'white', fontWeight: 500 }}
          component='h4'>
          {facilityGroup?.name || t('facilityGroups.details.title')}
        </Typography>
      </Box>
    </CardHeader>
  );

  if (loading) {
    return (
      <PageLayout header={header}>
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress />
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout header={header}>
      <FacilityGroupDetailsSection
        facilityGroup={facilityGroup}
        organizationId={organizationId}
        onUpdate={handleUpdate}
      />

      <FacilityAssignmentSection
        facilityGroup={facilityGroup}
        organizationId={organizationId}
        onUpdate={handleUpdate}
      />
    </PageLayout>
  );
};

export default FacilityGroupDetails;
